import { ChallengeRepository } from '../../data/local/challengeRepository'
import { caravanDb } from '../../services/syncRuntime'

export const challengeRepository = new ChallengeRepository(caravanDb)
